import React from "react";
import { Icon } from "react-fa";

const Checklist = props => (
  <ul>
    {props.items.map(item => (
      <li key={"item-" + item.key}>
        <div className="level is-mobile">
          <div className="level-left">
            <div className="level-item">
              <div className="level-item">
                <Icon className="fa has-text-brand" name="check" />
              </div>
              <p>{item.name}</p>
            </div>
          </div>
          <div className="level-right"></div>
        </div>
      </li>
    ))}
  </ul>
);

export default Checklist;



// WEBPACK FOOTER //
// ./src/pages/About/components/Checklist.js